/*
 * kelltoncommerce
 * version 1.0
 * http://www.kelltoncommerce.com
 *
 * Copyright (c) 2023  kellton tech solution limited
 * Author kellton ltd <support@kellton.com>
 * Licensed under the MIT license.
 */
import { NgModule } from '@angular/core';
import { OnlyNumberDirective } from './only-number.directive';

@NgModule({
  declarations: [OnlyNumberDirective],
  exports: [OnlyNumberDirective]
})
export class NumberAcceptModule {}
